module.exports = __webpack_public_path__ + "static/media/house_black_active.4ad709dd.svg";